import {
  fetchActivesAndUsedCategories,
  fetchCategories,
  fetchCategory,
  fetchInternalCategories,
  fetchMultipleCategories,
  fetchReapproCategories,
  fetchReapproCategoryAlgorithms,
} from '../queries/categories.queries'

import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'

export const useCategories = () =>
  useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
  })

const internalCategoriesOptions = queryOptions({
  queryKey: ['internalCategories'],
  queryFn: fetchInternalCategories,
})

export const useInternalCategories = () => useQuery(internalCategoriesOptions)

export const useInternalCategory = (id?: number) =>
  useQuery({
    ...internalCategoriesOptions,
    select: id !== undefined ? (data) => data.find((category) => category.id === id) : undefined,
    enabled: id !== undefined && !Number.isNaN(id),
  })

const reapproCategoriesOptions = queryOptions({
  queryKey: ['reapproCategories'],
  queryFn: fetchReapproCategories,
})

export const useReapproCategories = () => useQuery(reapproCategoriesOptions)

export const useReapproCategory = (id?: number) =>
  useQuery({
    ...reapproCategoriesOptions,
    select: (data) => data.find((category) => category.id === id),
    enabled: id !== undefined && !Number.isNaN(id),
  })

const reapproCategoryAlgorithmsOptions = queryOptions({
  queryKey: ['reapproCategoryAlgorithms'],
  queryFn: fetchReapproCategoryAlgorithms,
})

export const useReapproCategoryAlgorithms = () => useQuery(reapproCategoryAlgorithmsOptions)

export const useActivesAndUsedCategories = (storeId: number) =>
  useQuery({
    queryKey: ['activesAndUsedCategories', storeId],
    queryFn:
      Number.isNaN(storeId) || storeId === 0
        ? skipToken
        : () => fetchActivesAndUsedCategories(storeId),
  })

export const useCategory = (id?: number) =>
  useQuery({
    queryKey: ['category', id],
    queryFn: id ? () => fetchCategory(id) : skipToken,
  })

export const useMultipleCategories = (ids: number[]) =>
  useQuery({
    queryKey: ['multipleCategories', ids],
    queryFn: () => {
      if (ids.length === 0) {
        return []
      }
      return fetchMultipleCategories(ids)
    },
  })
